import { render, staticRenderFns } from "./ExternalHtml.vue?vue&type=template&id=0003423e&"
import script from "./ExternalHtml.vue?vue&type=script&lang=js&"
export * from "./ExternalHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/ExternalHtml.vue
// module id = 1761
// module chunks = 0